export const dateToLocalDateString = (date: Date): string => {
  return date.toLocaleDateString('pt-BR');
};
